import { Component, Injectable, Input, OnInit } from '@angular/core';
import { TableColumn } from '@shared/components/tables/tables.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

const headers = new HttpHeaders({
  'x-no-notification': 'true'
});
const baseUrl = `${environment.apiBaseUrl}platform/teams`;

@Injectable({
  providedIn: 'root'
})
export class CodeQualityDataService {
  constructor(private http: HttpClient) {}

  getDataList(params: HttpParams): Observable<any> {
    return this.http.post<any>(
      `${baseUrl}/executive-teams`,
      { ...params },
      { headers }
    );
  }
}

@UntilDestroy()
@Component({
  selector: 'app-sonar-metrics-table',
  template: `
    <app-tables
      [pageSize]="10"
      [columns]="columns"
      [remoteLoadFn]="remoteLoad"
      [queryParams]="queryParams"
    ></app-tables>
  `
})
export class MetricsTableComponent implements OnInit {
  @Input() selectedDate: any;
  projectId: string;
  widgetEnum = 'CODE_QUALITY_OVERVIEW_METRICS';
  queryParams = {};
  columns: TableColumn[] = [
    {
      title: 'Teams',
      key: 'teams',
      render(row:any){
        return row.team.label	;
      }
    },
    {
      title: 'Unit Level',
      key: 'unitLevel',
      render(row:any){
        return row.unitLevel.label;
      }
    },
    {
      title: 'Projects',
      key: 'numberOfProjects'
    },
    {
      title: 'Technical Debt',
      key: 'techDept'
    },
    {
      title: 'Duplications',
      key: 'duplications'
    },
    {
      title: 'Cyclomatic Complexity',
      key: 'cyclomaticComplexity'
    },
    {
      title: 'Cognitive Complexity',
      key: 'cognitiveComplexity'
    },
    {
      title: 'Cognitive Complexity',
      key: 'cognitiveComplexity'
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private CodeQalityDataService: CodeQualityDataService
  ) {
    route.params.pipe(untilDestroyed(this)).subscribe(response => {
      this.projectId = response.id;
    });
  }

  ngOnInit(): void {
    this.queryParams = {
      projectId: this.projectId,
      widgetEnum: this.widgetEnum,
      from: this.selectedDate.from,
      to: this.selectedDate.to,
    };
  }

  remoteLoad = (params: any) => {
    params = {
      widgetEnum: 'CODE_QUALITY_OVERVIEW_METRICS',
      teamId: this.projectId,
      from: params.from,
      to: params.to,
      page: params.pageIndex,
      pageSize: params.pageSize,
      selectedFilters: { teamName: [], levelName: [] }
    };
    return this.CodeQalityDataService.getDataList(params);
  };
}
